import React from "react"
import { MpLoader } from "../../../mp-shared-components/ready-shared-components/components/mpLoader"

const Loader = React.memo(() => (
  <div className="preloader-wrapper mb-4">
    <MpLoader />
  </div>
))

export default Loader
